import { useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import './CartDropdown.css';

function formatPrice(value) {
  return new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0,
  }).format(value);
}

function CartDropdown({ isOpen, onClose }) {
  const { items, removeItem, updateQuantity, totalPrice } = useCart();
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        onClose();
      }
    }
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="cart-dropdown" ref={dropdownRef}>
      <div className="cart-dropdown-header">
        <h3>Mi carrito de compras</h3>
        <button className="cart-dropdown-close" onClick={onClose}>✕</button>
      </div>

      {items.length === 0 ? (
        <p className="cart-dropdown-empty">Tu carrito está vacío</p>
      ) : (
        <>
          <div className="cart-dropdown-items">
            {items.map((item) => (
              <div
                key={`${item.productId}_${item.precioId}_${item.colorId}`}
                className="cart-dropdown-item"
              >
                <div className="cart-dropdown-item-img">
                  {item.imagen ? (
                    <img src={item.imagen} alt={item.nombre} />
                  ) : (
                    <div className="cart-dropdown-item-placeholder" />
                  )}
                </div>
                <div className="cart-dropdown-item-info">
                  <span className="cart-dropdown-item-brand">{item.marca}</span>
                  <span className="cart-dropdown-item-name">{item.nombre}</span>
                  {item.precioDescripcion && (
                    <span className="cart-dropdown-item-detail">{item.precioDescripcion}</span>
                  )}
                  {item.colorNombre && (
                    <span className="cart-dropdown-item-detail">
                      <span
                        className="cart-dropdown-color-dot"
                        style={{ backgroundColor: item.colorHex }}
                      />
                      {item.colorNombre}
                    </span>
                  )}
                  <div className="cart-dropdown-item-qty">
                    <button
                      onClick={() =>
                        updateQuantity(item.productId, item.precioId, item.colorId, item.cantidad - 1)
                      }
                      disabled={item.cantidad <= 1}
                    >
                      −
                    </button>
                    <span>{item.cantidad}</span>
                    <button
                      onClick={() =>
                        updateQuantity(item.productId, item.precioId, item.colorId, item.cantidad + 1)
                      }
                    >
                      +
                    </button>
                  </div>
                </div>
                <div className="cart-dropdown-item-right">
                  <span className="cart-dropdown-item-price">
                    {formatPrice(item.precioValor * item.cantidad)}
                  </span>
                  <button
                    className="cart-dropdown-item-remove"
                    onClick={() => removeItem(item.productId, item.precioId, item.colorId)}
                    title="Eliminar"
                  >
                    🗑
                  </button>
                </div>
              </div>
            ))}
          </div>

          <div className="cart-dropdown-footer">
            <div className="cart-dropdown-total">
              <span>Total</span>
              <span className="cart-dropdown-total-value">{formatPrice(totalPrice)}</span>
            </div>
            <Link to="/carrito" className="cart-dropdown-view-btn" onClick={onClose}>
              Ver carrito
            </Link>
          </div>
        </>
      )}
    </div>
  );
}

export default CartDropdown;
